package ui.external.materialui

object FormControlMargin {
    const val normal = "normal"
}
